import { useStyles } from './Bullet.styles';

export const Bullet = () => {
  const classes = useStyles();

  return <div css={classes.bullet} />;
};
